function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EDEDED",
  fillRule: "evenodd",
  d: "M122.516851,145.10429 C126.417259,145.10429 129.589844,141.929903 129.589844,138.028452 C129.589844,134.125935 126.417259,130.952613 122.516851,130.952613 C118.615385,130.952613 115.441741,134.125935 115.441741,138.028452 C115.441741,141.929903 118.615385,145.10429 122.516851,145.10429 Z M141.644401,173.736581 L141.644401,165.302419 L135.210367,159.142065 L126.506121,167.019484 C124.976424,168.327774 122.833157,168.302226 121.330966,166.963065 L99.0953604,147.43771 L77.2056823,165.358839 L77.2056823,173.736581 L141.644401,173.736581 Z M77.2056823,126.262355 L77.2056823,154.837161 L96.6548285,138.980129 C98.1855826,137.70271 100.608131,137.743161 102.094454,139.070613 L123.990479,158.564032 L133.131631,150.727065 C134.638053,149.437935 136.305274,149.440065 137.810639,150.735581 L141.644401,154.633839 L141.644401,126.262355 L77.2056823,126.262355 Z M152,178.36829 C152,180.926323 149.939247,183 147.397159,183 L72.6028412,183 C70.0607526,183 68,180.926323 68,178.36829 L68,121.63171 C68,119.072613 70.0607526,117 72.6028412,117 L147.397159,117 C149.939247,117 152,119.072613 152,121.63171 L152,178.36829 Z",
  transform: "translate(-68 -117)"
});

function SvgIconNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 75,
    viewBox: "0 0 84 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoImage);
export default __webpack_public_path__ + "static/media/icon_no_image.dc8939bf.svg";
export { ForwardRef as ReactComponent };